module.exports = __webpack_public_path__ + "img/brand (10).5bd2d8d6.svg";